import BaseModel from './base-model';

/**
 * format:
 * @COMMON_NAME: "Peticion.acude.vue"
 * @REL_ATTR: "pcat:406005"
 * @id: 406005
 */
export default class ElementCategory extends BaseModel {
  constructor(opts = {}) {
    super(opts);
  }
}
